module.exports = __webpack_public_path__ + "static/media/106.978e4175.jpg";